// extracted by mini-css-extract-plugin
export default {"tupacGrid":"eo-z","tupacHeader":"fo-z","tupacHeader2":"go-z","tupacMenu":"ho-z","tupacMenu2":"io-z","tupacMain":"jo-z","tupacMain2":"ko-z"};